import React from 'react';
import Link from 'next/link';
import CustomizeBox from '../../components/CustomizeBox';
import { GalleryItemWithBundle } from '../../types';
import { Disclosure } from '@headlessui/react';
import IconTriangleDown from '../../components/IconTriangleDown';
import AnimateHeight from '../../components/AnimateHeight';
import { getItemUrl } from 'utils/utils';

interface LightBoxItemProps {
  error: boolean;
  lightBoxItem: GalleryItemWithBundle;
}

type Props = React.FC<React.HTMLAttributes<HTMLDivElement> & LightBoxItemProps>;

const LightBoxItem: Props = ({ lightBoxItem, error, className, ...props }) => {
  return (
    <div {...props} className={` ${className ? className : ''}`}>
      {lightBoxItem.bundle ? (
        <div className="space-y-16">
          <CustomizeBox
            product={lightBoxItem.bundle}
            isBlockedOut={false}
            isComingSoonBlockedOut={false}
            builderQueryString={`?bundle_ids=${lightBoxItem.bundle.id}`}
          />

          <Link href={'/collection/[category]/[product]'} as={getItemUrl(lightBoxItem.bundle)}>
            <button className="btn-info-outline tracker-cta-gallery-lightbox-20190218-171521 btn w-full">View Product</button>
          </Link>
        </div>
      ) : (
        <p className="text-gray-dark">Product No Longer Available</p>
      )}
      <div className="divide-y-1 divide-solid divide-gray-light">
        {!error && lightBoxItem.bundle && (
          <>
            <Disclosure as="div">
              {({ open }) => (
                <>
                  <Disclosure.Button className="group flex w-full items-center justify-start">
                    <h3 className="text-h5 py-16 text-gray-dark group-hover:text-blue-dark">Details</h3>

                    <IconTriangleDown
                      className={`ml-auto fill-current transition duration-150 group-hover:text-blue-dark ${
                        open ? '' : 'rotate-90 transform'
                      }`}
                    />
                  </Disclosure.Button>

                  <AnimateHeight open={open}>
                    <Disclosure.Panel static className="pb-16">
                      {lightBoxItem.bundle.details!.map((d: any) => (
                        <p className="text-sm text-gray-dark" key={d.id}>
                          - {d.detail}
                        </p>
                      ))}
                    </Disclosure.Panel>
                  </AnimateHeight>
                </>
              )}
            </Disclosure>

            <Disclosure as="div">
              {({ open }) => (
                <>
                  <Disclosure.Button className="group flex w-full items-center justify-start">
                    <h3 className="text-h5 py-16 text-gray-dark group-hover:text-blue-dark">Stylist Notes</h3>

                    <IconTriangleDown
                      className={`ml-auto fill-current transition duration-150 group-hover:text-blue-dark ${
                        open ? '' : 'rotate-90 transform'
                      }`}
                    />
                  </Disclosure.Button>

                  <AnimateHeight open={open}>
                    <Disclosure.Panel static className="pb-16">
                      <p className="pb-16 text-sm">{lightBoxItem.bundle.short_description}</p>
                    </Disclosure.Panel>
                  </AnimateHeight>
                </>
              )}
            </Disclosure>
          </>
        )}

        <div>
          <h4 className="text-h5 py-16 text-gray-dark">Tags</h4>

          <ul className="pb-16">
            {lightBoxItem.type && <li className="text-sm capitalize">{lightBoxItem.type}</li>}

            {lightBoxItem.category && <li className="text-sm capitalize">{lightBoxItem.category}</li>}

            {lightBoxItem.color && <li className="text-sm capitalize">{lightBoxItem.color}</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LightBoxItem;
